import { gql } from "@apollo/client";

//queries

export const QUERY_LOCKER_TYPE = gql`
  query {
    lockerTypes {
      lockerTypeId
      lockerType
    }
  }
`;

export const QUERY_LOCKER_NAME = gql`
  query ($operatorId: ID!, $selectedLockerType: Int) {
    lockers(operatorId: $operatorId, lockerTypeId: $selectedLockerType) {
      lockerName
      lockerId
    }
  }
`;

export const QUERY_COMPANY_BRANCHES = gql`
  query ($operatorId: ID!, $selectedPartnerCompany: ID) {
    searchBranches(
      operatorId: $operatorId
      partnerId: $selectedPartnerCompany
    ) {
      partnerBranchId
      partnerBranch
    }
  }
`;
export const QUERY_COMPANY_NKCNAME = gql`
  query ($operatorId: ID!) {
    partners(operatorId: $operatorId) {
      partnerId
      companyNickname
    }
  }
`;

export const QUERY_POD_DATA = gql`
  query (
    $operatorId: Int!
    $paymentCurrency: String
    $transactionDateStart: String!
    $transactionDateEnd: String!
    $transactionStatus: String
    $transactionId: String
    $lockerIds: [Int]
    $mobileNumber: String
    $waybillNumber: String
  ) {
    transactions(
      operatorId: $operatorId
      paymentCurrency: $paymentCurrency
      transactionDateStart: $transactionDateStart
      transactionDateEnd: $transactionDateEnd
      transactionStatus: $transactionStatus
      transactionId: $transactionId
      lockerIds: $lockerIds
      mobileNumber: $mobileNumber
      waybillNumber: $waybillNumber
    ) {
      packageId
      packageDate
      packageStateNo
      transactionId
      lockerId
      lockerName
      paymentDate
      paymentId
      paymentCurrency
      __typename
      recipientId
      recipientMobile
      userAccountId
      partnerAgentId
      partnerAgentMobile
      status
      waybillNumber
      packagePrice
      transactionFee
      userId
      paymentAmount
    }
  }
`;

export const POD_SUMMARY_DATA_QUERY = gql`
  query (
    $operatorId: Int!
    $transactionDateStart: String!
    $transactionDateEnd: String!
    $lockerIds: [Int]
  ) {
    podSummary(
      operatorId: $operatorId
      transactionDateStart: $transactionDateStart
      transactionDateEnd: $transactionDateEnd
      lockerIds: $lockerIds
    ) {
      lockerId
      lockerName
      paymentCurrency
      earliestPackage
      latestPackage
      packages
      totalPrice
      totalFees
      totalPayments
      percentPerLockerPayments
      percentPerLockerPrice
      percentPerLockerPackages
      __typename
    }
  }
`;

export const AGGREGATE_POD_TRANSACTIONS = gql`
  query (
    $operatorId: Int!
    $transactionDateStart: String!
    $transactionDateEnd: String!
    $transactionStatus: String
    $lockerIds: [Int]
    $mobileNumber: String
    $waybillNumber: String
  ) {
    aggregatePodTransactions(
      operatorId: $operatorId
      transactionDateStart: $transactionDateStart
      transactionDateEnd: $transactionDateEnd
      transactionStatus: $transactionStatus
      lockerIds: $lockerIds
      mobileNumber: $mobileNumber
      waybillNumber: $waybillNumber
    ) {
      paymentCurrency
      lockerId
      lockerName
      packageStateNo
      paymentAmount
      status
      totalTransactions
      __typename
    }
  }
`;
